import { FC, useContext, useState } from "react";
import NotificationDispatch, {
  showErrorNotification,
  showSuccessNotification,
} from "../../context/notificationContext";
import { useI18n } from "../../hooks/useTranslations";
import { useRolesApi } from "../../http/roles/api";
import { Role } from "../../http/roles/types";
import ModalDialog from "../ui/ModalDialog";

type DeleteRoleDialogProps = {
  role: Role;
  onClose: () => void;
};

const DeleteRoleDialog: FC<DeleteRoleDialogProps> = ({ onClose, role }) => {
  const i18n = useI18n();
  const rolesApi = useRolesApi();
  const dispatch = useContext(NotificationDispatch);
  const [isSubmitting, setIsSubmitting] = useState(false);

  return (
    <ModalDialog
      onClose={onClose}
      title={i18n.t.roles.delete}
      isSubmitting={isSubmitting}
      actions={[
        {
          title: i18n.t.common.cancel,
          type: "secondary",
          onClick: onClose,
        },
        {
          title: i18n.t.common.yes,

          onClick: () => {
            setIsSubmitting(true);
            rolesApi
              .deleteAdminRole(role.id)
              .then(onClose)
              .catch((err) => dispatch(showErrorNotification(i18n, err)))
              .finally(() => {
                setIsSubmitting(false);
                dispatch(showSuccessNotification(i18n.t));
              });
          },
        },
      ]}
    >
      {i18n.t.roles.questions.delete}
    </ModalDialog>
  );
};

export default DeleteRoleDialog;
